import { createSlice } from "@reduxjs/toolkit";
import { type } from "@testing-library/user-event/dist/type";
import _ from "lodash";

const initialMedicationState = {
  error: null,
  isFavorite: false,
  isEdit: false,
  isBulk: false,
  hideTabs:'',
  isExtracted: false,
  flow: "newERX",
  medication: {},
  completeData: {},
  medicationIntractionData: {},
  EPCAlert:false,
  transmissionAlert:false,
  printResData:{},
  showPrintDialog:false
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const medicationSlice = createSlice({
  name: "medication",
  initialState: initialMedicationState,
  reducers: {
    setMedication: (state, action) => {
      const {
        medication = {},
        isFavorite = false,
        isExtracted = false,
        isEdit = false,
        isBulk = false,
        flow = "newERX",
        isAssesment = false,
        typeAssesment = "",
        type="",
        hideTabs='',
        EPCAlert=false,
        transmissionAlert=false,
        showPrintDialog=false,
        showTag="Extracted"
        
      } = action.payload;
      return {
        ...state,
        medication: medication,
        isFavorite: isFavorite,
        isEdit: isEdit,
        isBulk: isBulk,
        isExtracted: isExtracted,
        flow: flow,
        isAssesment: isAssesment,
        typeAssesment: typeAssesment,
        type:type,
        hideTabs:hideTabs,
        EPCAlert:EPCAlert,
        transmissionAlert:transmissionAlert,
        showPrintDialog:showPrintDialog,
        showTag:showTag
      };
    },
    addMedication: (state, action) => {

      const { problem, patientId } = action.payload;
      let data = _.cloneDeep(state.problems);

      data[patientId] = problem.all;
      state.problems = data;
      state.error = null;
      state.listLoading = false;
    },

    setMedicationIntractionData: (state, action) => {
      state.medicationIntractionData = action.payload;
    },
    setMedicationPrintData: (state, action) => {
      state.printResData = action.payload;
    }
  },
});

export const { setMedication, setMedicationIntractionData,setMedicationPrintData } =
  medicationSlice.actions;
